module.exports = __webpack_public_path__ + "img/fiveTemBg.7e64b2a6.jpg";